import React, { useEffect, useState, useRef } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import {
  DocumentDownloadIcon,
  DotsHorizontalIcon,
  PlusCircleIcon,
} from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import { Menu, Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import Paginate from "../../utils/Paginate";
import { convert, formatDate } from "./../../utils/convertDate";
import DatePicker from "react-date-picker";
import AccountOfficerServices from "../../services/AccountOfficerServices";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import TenantServices from "../../services/TenantServices";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AccountOfficer() {
    const data = {
        bvn: "",
        name: "",
        code: "",
        alternativePhoneNumber: "",
        emailAddress: "",
        phoneNumber: "",
        branchName: "",
        branchAddress: ""
    }

    const [formValue, setFormValue] = useState(data)
    const [accounts, setAccount] = useState([])
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false)
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("")
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));
    const [open, setOpen] = useState(false);
    const cancelButtonRef = useRef(null);
    const [editModal, setViewOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [branch, setBranch] = useState([]);

    const listAccountOfficer = async (search, from, to) => {
        const account = await AccountOfficerServices.listAccountOfficer(pageIndex, 10, search, from, to);
        setAccount([...account.data.result]);
        setPageLength([...account.data.result].length);
        setPageNumber(account.data.totalCount);
        setPageIndex(account.data.pageIndex);
        setPrev(account.data.hasPreviousPage);
        setPage(account.data.totalPages);
        setNextPage(account.data.hasNextPage);

    }
    const searchAccount = async (text) => {

        setSearch(text);
    };


  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    setFrom(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to);
    setToo(convert(toDate));

    listAccountOfficer(search, from, convert(toDate));
  };
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };
  const handleExport = async () => {
    const resp = await AccountOfficerServices.exportAcct(search, fromm, too);
    window.open(resp.data);
  };
  // comment validation
  const formHandler = {
    nameHandler: (event) => {
      setFormValue({ ...formValue, name: event.target.value });
    },
    bvnHandler: (event) => {
      setFormValue({ ...formValue, bvn: event.target.value });
    },
    codeHandler: (event) => {
      setFormValue({ ...formValue, code: event.target.value });
    },
    altPhoneNumberHandler: (event) => {
      setFormValue({
        ...formValue,
        alternativePhoneNumber: event.target.value,
      });
    },
    emailHandler: (event) => {
      setFormValue({ ...formValue, emailAddress: event.target.value });
    },
    phoneHandler: (event) => {
      setFormValue({ ...formValue, phoneNumber: event.target.value });
    },
    branchNameHandler: (event) => {
      setFormValue({ ...formValue, branchName: event.target.value });
    },
    branchAddressHandler: (event) => {
      setFormValue({ ...formValue, branchAddress: event.target.value });
    },
  };
  const updateOfficer = async (e) => {
    setLoading(true);
    e.preventDefault();
    const resp = await AccountOfficerServices.editAccountOfficer(formValue);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setViewOpen(false);
        window.location.reload();
      }, 2000);
      setLoading(false);
    }
  };
  const addOfficer = async (e) => {
    e.preventDefault();
    const create = await AccountOfficerServices.addAccountOfficer(formValue);
    if (create) {
      fire("success", create.message);
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 2000);
    }
  };
  const createOfficer = async () => {
    setOpen(true);
    setFormValue({
      ...formValue,
      bvn: "",
      name: "",
      code: "",
      alternativePhoneNumber: "",
      emailAddress: "",
      phoneNumber: "",
      branchName: "",
      branchAddress: "",
    });
  };
  const handleUpdate = async (e) => {
    setViewOpen(true);
    setFormValue({
      ...formValue,
      bvn: e.bvn,
      name: e.name,
      code: e.code,
      alternativePhoneNumber: e.alternativePhoneNumber,
      emailAddress: e.emailAddress,
      phoneNumber: e.phoneNumber,
      branchName: e.branchName,
      branchAddress: e.branchAddress,
    });
    const resp = await AccountOfficerServices.editAccountOfficer(formValue);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setViewOpen(false);
        window.location.reload();
      }, 2000);
    }
  };
  const deleteOfficer = async (text) => {
    const resp = await AccountOfficerServices.deleteOfficer({
      code: text,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };
  const viewAccount = async (code) => {
    window.location.href = `/accounts?code=${code}`;
  };
  const handleClose = async () => {
    setOpen(false);
  };
  const getOrganization = async () => {
    var tenant = sessionStorage.getItem("tenantId");
    const resp = await TenantServices.listTenanat(tenant);
    setBranch([...resp.data.organizationBranches]);
  };

    useEffect(() => {
        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        listAccountOfficer(search, from?? "", toDate);
        getOrganization();
    }, [pageIndex]);
    return (<>
        <Layout title="Account Officer" pageTag={'account'} current={'/officers'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto '>
                        <div className=''>
                            <div className="">
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto flex">

                                        <div className=" relative rounded-md shadow-sm ml-3">
                                            <p className='text-sm leading-3 text-gray-500'>From</p>
                                            <div>
                                                <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                            </div>
                                        </div>
                                        <div className=" relative rounded-md shadow-sm ml-3">
                                            <p className='text-sm leading-3 text-gray-500'>To</p>
                                            <div>
                                                <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                            </div>
                                        </div>
                                        <div className="mt-5 ml-3 relative rounded-md shadow-sm">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </div>
                                            <input
                                                type="text"
                                                name="user"
                                                id="user"
                                                onChange={(e) => searchAccount(e.target.value)}
                                                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                                placeholder="Search officer"
                                            />
                                        </div>
                                        <div className='mt-5 ml-4'>
                                            <button
                                                onClick={range}
                                                className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                        </div>
                                        <div className="mt-5 ml-4 flex justify-end">
                                            <button
                                                type="button"
                                                onClick={handleExport}
                                                className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent hover:text-white btn-green px-3 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                                            >
                                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                                Export CSV
                                            </button>
                                        </div>
                                        <div className='mt-5 ml-4'>
                                            <button
                                                type="button"
                                                onClick={() => createOfficer()}
                                                className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                            >
                                                <PlusCircleIcon className="w-4 mr-1.5" />
                                                Add Officer
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {accounts.length === 0 ?
                                    (
                                        <div className="mt-8"> No data available for these dates to show. </div>
                                    ) :
                                    <>
                                        <div className="mt-8 flex ">
                                            <div className="-my-2  overflow-x-auto ">
                                                <div className="inline-block min-w-full py-2 align-middle mb-20 ">
                                                    <div className="relative h-screen  ring-black ring-opacity-5 md:rounded-lg">
                                                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                                                        Officer Name
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Officer BVN
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Officer Code
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Alternative Phone Number
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Email Address
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Phone Number
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Branch Name
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Branch Address
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Account Opened
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Date Account Created
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">

                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                        <span className="sr-only">Edit</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>

                                                            <tbody className="divide-y divide-gray-200 bg-white">

                                                                {accounts.map((person, i) => (
                                                                    <tr key={i} className="bg-gray-50">
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.name} </td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900"> {person.bvn} </td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.code}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.alternativePhoneNumber}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.emailAddress}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.phoneNumber}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branchName}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branchAddress}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.totalAccountOpen}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>
                                                                        <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" value={person.id}>
                                                                            <Menu as="div" className="ml-3  flex-shrink-0">
                                                                                <div>
                                                                                    <Menu.Button className="  flex text-sm text-white">
                                                                                        <span className="sr-only">Open user menu</span>
                                                                                        <DotsHorizontalIcon className='w-8 text-gray-400' />
                                                                                    </Menu.Button>
                                                                                </div>
                                                                                <Transition
                                                                                    as={Fragment}
                                                                                    enter="transition ease-out duration-100"
                                                                                    enterFrom="transform opacity-0 scale-95"
                                                                                    enterTo="transform opacity-100 scale-100"
                                                                                    leave="transition ease-in duration-75"
                                                                                    leaveFrom="transform opacity-100 scale-100"
                                                                                    leaveTo="transform opacity-0 scale-95"
                                                                                >
                                                                                    <Menu.Items className="origin-top-right absolute right-6 mt-2 w-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => viewAccount(person.code)}
                                                                                            className="block py-2 px-5 text-sm text-gray-700 text-left">
                                                                                            View Account Opened
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => handleUpdate(person)}
                                                                                            className="block py-2 px-5 text-sm text-gray-700 text-left">
                                                                                            Edit Officer
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => deleteOfficer(person.code)}
                                                                                            className="block py-2 px-5 text-sm text-gray-700 text-left">
                                                                                            Delete Officer
                                                                                        </button>
                                                                                    </Menu.Items>
                                                                                </Transition>
                                                                            </Menu>

                                                                        </td>
                                                                    </tr>
                                                                ))}


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Paginate
                                            nextPage={nextPage}
                                            pageIndex={pageIndex}
                                            totalCount={pageNumber}
                                            totalPages={totalPage}
                                            prevPage={prevPage}
                                            setPageIndex={setPageIndex}
                                        />
                                    </>
                                }


                            </div>

                        </div>
                    </div>
                </main>


          {/* Create modal */}
          <Transition.Root show={open} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="text-3xl">Add Officer</div>
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="name"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Enter officer name"
                                    value={formValue.name}
                                    onChange={formHandler.nameHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="bvn"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  BVN
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="bvn"
                                    name="bvn"
                                    type="text"
                                    placeholder="Enter officer bvn"
                                    value={formValue.bvn}
                                    onChange={formHandler.bvnHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="emailAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Email Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="emailAddress"
                                    name="emailAddress"
                                    type="email"
                                    placeholder="Enter officer email"
                                    value={formValue.emailAddress}
                                    onChange={formHandler.emailHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="code"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Officer Code
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="code"
                                    name="code"
                                    type="text"
                                    placeholder="Enter officer code"
                                    value={formValue.code}
                                    onChange={formHandler.codeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Phone Number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer phone"
                                    value={formValue.phoneNumber}
                                    onChange={formHandler.phoneHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Alternative Phone number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer alternative phone"
                                    value={formValue.alternativePhoneNumber}
                                    onChange={formHandler.altPhoneNumberHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Name
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select branch name"
                                    id="role"
                                    name="branchName"
                                    onChange={formHandler.branchNameHandler}
                                    value={formValue.branchName}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select branch name"
                                  >
                                    <option value="">
                                      Select branch address
                                    </option>
                                    {branch.map((item, i) => (
                                      <option key={i} value={item.branchName}>
                                        {item.branchName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Address
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select branch address"
                                    id="branchAddress"
                                    name="branchAddress"
                                    onChange={formHandler.branchAddressHandler}
                                    value={formValue.branchAddress}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select branch address"
                                  >
                                    <option value="">
                                      Select branch address
                                    </option>
                                    {branch.map((item, i) => (
                                      <option
                                        key={i}
                                        value={item.branchAddress}
                                      >
                                        {item.branchAddress}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                              onClick={addOfficer}
                            >
                              Add
                            </button>
                            <button
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                              onClick={() => setOpen(false)}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>

          {/* update modal */}
          <Transition.Root show={editModal} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="text-3xl">Update Officer</div>
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="name"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Enter officer name"
                                    value={formValue.name}
                                    onChange={formHandler.nameHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="bvn"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  BVN
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="bvn"
                                    name="bvn"
                                    type="text"
                                    placeholder="Enter officer bvn"
                                    value={formValue.bvn}
                                    onChange={formHandler.bvnHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="emailAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Email Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="emailAddress"
                                    name="emailAddress"
                                    type="email"
                                    placeholder="Enter officer email"
                                    value={formValue.emailAddress}
                                    onChange={formHandler.emailHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="code"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Officer Code
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="code"
                                    name="code"
                                    type="text"
                                    placeholder="Enter officer code"
                                    disabled={true}
                                    defaultValue={formValue.code}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Phone Number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer phone"
                                    value={formValue.phoneNumber}
                                    onChange={formHandler.phoneHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="phoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Alternative Phone number
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="Enter officer alternative phone"
                                    value={formValue.alternativePhoneNumber}
                                    onChange={formHandler.altPhoneNumberHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Name
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select role"
                                    id="role"
                                    name="role"
                                    onChange={formHandler.branchNameHandler}
                                    value={formValue.branchName}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select role"
                                  >
                                    <option value="">
                                      {formValue.branchName}
                                    </option>
                                    {branch.map((item, i) => (
                                      <option key={i} value={item.branchName}>
                                        {item.branchName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Address
                                </label>
                                <div className="mt-1">
                                  <select
                                    placeholder="Select branch address"
                                    id="branchAddress"
                                    name="branchAddress"
                                    onChange={formHandler.branchAddressHandler}
                                    value={formValue.branchAddress}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Select role"
                                  >
                                    <option value="">
                                      {formValue.branchAddress}
                                    </option>
                                    {branch.map((item, i) => (
                                      <option
                                        key={i}
                                        value={item.branchAddress}
                                      >
                                        {item.branchAddress}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            {loading === false ? (
                              <button
                                type="button"
                                className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                                onClick={updateOfficer}
                              >
                                Update
                              </button>
                            ) : (
                              <HollowDotsSpinner size={40} color="#4D627E" />
                            )}

                            <button
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                              onClick={() => setViewOpen(false)}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </React.Fragment>
      </Layout>
    </>
  );
}
